// Every English string on the after-event wrap-up (Stage 2D), in one place.
import type { WrapUpReason } from './wrapUpTypes'

export const WU = {
  start: 'Wrap up the event',
  title: 'After the event',
  help: 'For each item: how much the dishes used, and what happens to what is left — keep it, send it back to the store, or throw it away.',
  colItem: 'Item',
  colPlanned: 'Recipes say',
  colKitchen: 'Kitchen has',
  colUsed: 'Used',
  colKeep: 'Keep',
  colBack: 'Send back',
  colThrow: 'Throw away',
  leftAfter: (n: string, unit: string) => `${n} ${unit} left in the kitchen after this`,
  reason: 'Why thrown away',
  reasons: { leftover: 'Left over', spoiled: 'Spoiled', burnt: 'Burnt', damaged: 'Damaged', expired: 'Expired', returned: 'Came back' } satisfies Record<WrapUpReason, string>,
  equipmentOut: 'Equipment still out',
  equipmentHint: 'Send it back from the plan once it is in — mark anything lost or broken there.',
  pin: 'Manager PIN (needed to throw anything away)',
  note: 'Note (optional)',
  notePlaceholder: 'Rain, fewer guests…',
  submit: 'Finish the wrap-up',
  saving: 'Saving…',
  done: 'Event wrapped up',
  cancel: 'Not now',
  nothing: 'No food on this plan to account for — finish the wrap-up to release what it holds.',
  openBatch: (name: string) => `${name} batch was never finished — finish or cancel it first.`,
  openBatchHint: 'Finish or cancel it on Make food.',
  acknowledgeOpen: 'Wrap up anyway — these batches never happened',
  summaryTitle: 'Wrapped up',
  summaryBy: (who: string, when: string) => `${who} · ${when}`,
  usedValue: 'Used (value)',
  wasteValue: 'Thrown away (value)',
  returnReq: (no: string) => `Sent back on ${no}`,
  equipmentStillOut: (n: number) => `${n} piece${n === 1 ? '' : 's'} of equipment still out`,
  bookingWrapped: 'Kitchen has wrapped up this event.',
} as const
